module.exports = __webpack_public_path__ + "img/46.zone_is_clean.1356dc88.svg";